export interface StorageItem {
  key: string
  value?: string
}

export const Storage = {
  async get ({ key }: { key: string }): Promise<{ value?: string }> {
    try {
      const value = localStorage.getItem(key)
      return { value: value ?? undefined }
    } catch (error) {
      console.warn('Storage.get failed:', error)
      return { value: undefined }
    }
  },

  async set ({ key, value }: { key: string, value: string }): Promise<void> {
    try {
      localStorage.setItem(key, value)
    } catch (error) {
      console.warn('Storage.set failed:', error)
    }
  },

  async remove ({ key }: { key: string }): Promise<void> {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.warn('Storage.remove failed:', error)
    }
  },

  async clear (): Promise<void> {
    try {
      localStorage.clear()
    } catch (error) {
      console.warn('Storage.clear failed:', error)
    }
  }
}

export const isSafariPWA = (): boolean => {
  return (
    window.matchMedia('(display-mode: standalone)').matches &&
    navigator.userAgent.includes('Safari') &&
    !navigator.userAgent.includes('Chrome')
  )
}

export const isNetworkConnected = async (): Promise<boolean> => {
  if (!navigator.onLine) {
    return false
  }

  // For Safari PWA, do an actual network check instead of relying on navigator.onLine
  if (isSafariPWA()) {
    try {
      // Simple network connectivity test
      const response = await fetch('/favicon.ico', {
        method: 'HEAD',
        cache: 'no-cache',
        signal: AbortSignal.timeout(3000)
      })
      return response.ok
    } catch {
      return false
    }
  }

  return navigator.onLine
}
